<template>
    <div class="on">
        <Row>
            <Col span="24">
                <div class="header-black"></div>
                <div class="header-menu">
                    <Row>
                        <Col span="24">
                            <Menu mode="horizontal" :theme="theme1" active-name="1" style="height: 100px;">
                                <MenuItem name="1" to="/home">
                                    <Icon type="ios-home"/>
                                    大赛首页
                                </MenuItem>
                                <MenuItem name="2" to="/info/intro">
                                    <Icon type="ios-ribbon-outline"/>
                                    大赛简介
                                </MenuItem>
                                <MenuItem name="3" to="/info/notice">
                                    <Icon type="md-book"/>
                                    参赛须知
                                </MenuItem>
                                <MenuItem name="4" to="/info/arrange">
                                    <Icon type="ios-paper-plane-outline"/>
                                    赛事安排
                                </MenuItem>
                                <!--<MenuItem name="93" to="/info/news">-->
                                <!--<Icon type="ios-ribbon-outline"/>-->
                                <!--大赛新闻-->
                                <!--</MenuItem>-->
                                <MenuItem name="5" to="/info/team_show">
                                    <Icon type="ios-people"/>
                                    团队展示
                                </MenuItem>
                                <MenuItem name="33" to="/info/org">
                                    <Icon type="ios-person-outline"/>
                                    组织机构
                                </MenuItem>
                                <!--<Submenu name="6" to="/personal/create_team">-->
                                <!--<template slot="title">-->
                                <!--<Icon type="ios-person-outline"/>-->
                                <!--个人中心-->
                                <!--</template>-->
                                <!--<MenuItem name="6-1" to="/personal/create_team">团队管理</MenuItem>-->
                                <!--<MenuItem name="6-2" to="/personal/job">提交作品</MenuItem>-->
                                <!--<MenuItem name="6-3" to="/personal/audit">报名情况</MenuItem>-->
                                <!--</Submenu>-->
                                <MenuItem name="34" to="/info/contact">
                                    <Icon type="logo-twitch"/>
                                    联系我们
                                </MenuItem>
                            </Menu>
                        </Col>
                    </Row>
                </div>
                <img class="header-logo" :src="url+'/static/img/logo.png'">
                <div style="height:60px;"></div>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {Menu, MenuItem, Icon, Submenu, MenuGroup, Input, Row, Col} from 'iview';
    import {url} from '../../config';

    export default {
        name: 'on',
        components: {
            Menu,
            MenuItem,
            Icon,
            Submenu,
            MenuGroup,
            Input,
            Row,
            Col
        },
        data() {
            return {
                theme1: 'light',
                url: url,
            }
        },
        methods: {
            Jump(name) {
                this.$router.push({name: 'info_' + name, params: {ver_name: name}});
            }
        }
    }
</script>

<style lang="scss">
    .on {
        position: relative;

        .header-black{
            height:70px;
            background-color: rgba(102, 102, 102, 1);
        }
        .header-menu{
            margin-left:200px;
            position: absolute;
            right:0;

            .ivu-menu-item{
                padding:0;
                width:142.85px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
            }
        }
        .header-logo{
            width:170px;
            position: absolute;
            top:25px;
            left:15px;
        }
        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
            color: #ffffff !important;
            border-bottom: 0 !important;
            background-color: #800080;
        }

        .ivu-menu-horizontal {
            height: 60px !important;
            line-height: 60px !important;
        }

        .ivu-menu-horizontal.ivu-menu-light:after {
            height: 0 !important;
        }

        .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item {
            height: 50px !important;
            line-height: 50px !important;
            border-bottom: 0;
            float: none;
        }

        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
            color: #9933CC;
        }
    }
</style>
